export default "__VITE_ASSET__3m4wlyRZ__"